export const STORAGE_TOKEN = Symbol("STORAGE_TOKEN");
export const API_REQUEST_INTERCEPTORS = Symbol("API_REQUEST_INTERCEPTORS");
export const API_RESPONSE_INTERCEPTORS = Symbol("API_RESPONSE_INTERCEPTORS");
